import React from "react";
import { getCandidateStatusTypeMeta } from "../constants";

const CategoryPill = ({ category, className = "" }) => {
  const meta = getCandidateStatusTypeMeta(category);

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-medium leading-none ${meta.className} ${className}`}
    >
      {meta.label}
    </span>
  );
};

export default CategoryPill;